import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function ProblemSection() {
  const t = useT().problem;
  return <Section hasOrb={true} data-id="element-158">
      <Kicker data-id="element-159">{t.kicker}</Kicker>
      <H2 className="max-w-4xl" data-id="element-160">{t.title}</H2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16" data-id="element-161">
        {t.cards.map((prob, i) => <Card key={i} delay={i * 0.1} className="flex flex-col" data-id="element-162">
            <span className="font-archivo text-brand text-5xl mb-6 opacity-50" data-id="element-163">
              {prob.num}
            </span>
            <h3 className="font-archivo text-xl uppercase tracking-tight mb-4" data-id="element-164">
              {prob.title}
            </h3>
            <p className="text-ink-dim leading-relaxed" data-id="element-165">{prob.desc}</p>
          </Card>)}
      </div>
    </Section>;
}